/**
 * supabase.config.ts
 * Configuration Supabase pour l'application
 */
import { getEnv } from '../utils/envHelper';
import { logger } from '../utils/ProfessionalLogger';

export const SUPABASE_CONFIG = {
  url: getEnv('VITE_SUPABASE_URL', ''),
  anonKey: getEnv('VITE_SUPABASE_ANON_KEY', ''),
  googleFontsApiKey: getEnv('VITE_GOOGLE_FONTS_API_KEY', ''),
} as const;

// Validation de la configuration
if (!SUPABASE_CONFIG.url || !SUPABASE_CONFIG.anonKey) {
  logger.warn(
    'Configuration Supabase manquante. Assurez-vous que VITE_SUPABASE_URL et VITE_SUPABASE_ANON_KEY sont définis dans votre fichier .env',
    {},
    'supabase.config'
  );
}

export type SupabaseConfig = typeof SUPABASE_CONFIG;
